module.exports = __webpack_public_path__ + "static/media/Readersijeuni.3e6f3354.JPG";